import { DiscoverArtifactCommand } from "../../core/commands/DiscoverArtifactCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction, InteractionContext } from "../Interaction";
import type { ArtifactComponent, EntityComponent } from "../../world/components";

function undiscoveredArtifact(ctx: InteractionContext): ArtifactComponent | undefined {
  if (ctx.entity) {
    const artifact = getComponent(ctx.entity, "artifact");
    return artifact !== undefined && !artifact.discovered ? artifact : undefined;
  }
  if (ctx.inventoryItem) {
    const components = (ctx.inventoryItem.metadata as { components?: readonly EntityComponent[] } | undefined)?.components;
    const artifact = components?.find((c): c is ArtifactComponent => c.type === "artifact");
    return artifact !== undefined && !artifact.discovered ? artifact : undefined;
  }
  return undefined;
}

/** Progressively reveals an undiscovered artifact's true identity (e.g. "stone" -> "amber"). */
export const inspectInteraction: Interaction = {
  id: "inspect",
  label: "Inspect",
  canExecute: (ctx) => undiscoveredArtifact(ctx) !== undefined,
  execute: async (ctx) => {
    if (ctx.entity) {
      if (!undiscoveredArtifact(ctx)) return { success: false, message: "Nothing to inspect." };
      ctx.commands.execute(new DiscoverArtifactCommand(ctx.entity.id));
      return { success: true };
    }
    if (ctx.inventoryItem) {
      if (!undiscoveredArtifact(ctx)) return { success: false, message: "Nothing to inspect." };
      ctx.commands.execute(new DiscoverArtifactCommand(ctx.inventoryItem.instanceId));
      return { success: true };
    }
    return { success: false, message: "Nothing to inspect." };
  },
};
